import Backbone from 'backbone';
import Moment from 'moment';

export default Backbone.Model.extend({
    defaults: {
        id          : 0,
        account_id  : 0,
        project_id  : 0,
        portal_id   : 0,
        title       : '',
        content     : '',
        feature_image : '',
        feature_video : '',
        category      : '',
        reaction      : '',
        created_at  : 0,
        created_by    : 0,
        updated_at  : 0,
        updated_by    : 0,
        publish_time  : 0
    },

    isScheduled: function() {
        var publish_time = Moment(this.get('publish_time') * 1000);

        return publish_time.isAfter(Moment());
    },
});